import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

export function RequireTeacher({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  if (user.role !== 'teacher') return <Navigate to="/" replace />;
  if (!(user.email_verified && user.mobile_verified)) return <Navigate to={`/verify?uid=${user.id}`} replace />;
  return children;
}

export function RequireAdmin({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (!user) return <Navigate to="/admin/login" replace state={{ from: loc.pathname }} />;
  if (user.role !== 'admin') return <Navigate to="/admin/login" replace />;
  return children;
}

export function RequireLearner({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname + loc.search }} />;
  if (user.role !== 'learner') return <Navigate to="/" replace />;
  return children;
}

export function RequireStudent({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  if (user.role !== 'student') return <Navigate to="/" replace />;
  return children;
}
